module.exports = __webpack_public_path__ + "img/newchris-95.365eb280.jpg";